
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree2ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree2ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gYOZo", function(module, exports) {
module.exports = JSON.parse('[{"name":"Soldador Azul","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor. Incluye refuerzo en la palma para mayor durabilidad.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo Kevlar","Refuerzo":"Palma reforzada","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_azul_2.webp","Soldador_azul_3.webp","Soldador_azul_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["azul"]}},{"name":"Soldador Rojo","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo Kevlar que ofrecen alta resistencia al calor.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo Kevlar","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_rojo.webp","Soldador_rojo_2.webp","Soldador_rojo_3.webp","Soldador_rojo_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["rojo"]}},{"name":"Soldador Gris","info":"Guante de carnaza de res con tratamiento a base de aceite, dise\xf1ado para trabajos de soldadura y manejo de materiales calientes. Costuras con hilo de resistencia est\xe1ndar.","specs":{"Material":"Carnaza de res","Tratamiento":"A base de aceite","Forro":"Fieltro blanco (calibre 100\u2013120)","Costuras":"Hilo est\xe1ndar","Longitud":"14 pulgadas"},"category":"soldadura","imgs":["Soldador_gris.webp","Soldador_gris_2.webp","Soldador_gris_3.webp","Soldador_gris_par.webp"],"materials":["carnaza"],"colors":{"tag":"color","values":["gris"]}},{"name":"Argonero de piel","info":"Guante fabricado en piel de res de alta calidad, dise\xf1ado para ofrecer excelente durabilidad y comodidad. Cuenta con tira ajustable con broche que brinda un ajuste seguro. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Argonero","Ajuste":"Tira ajustable con broche","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"argon","materials":["piel"],"imgs":["Argonero_de_piel.webp","Argonero_de_piel_2.webp","Argonero_de_piel_3.webp","Argonero_de_piel_4.webp"],"colors":{"tag":"color","values":["amarillo natural"]}},{"name":"Argonero el\xe1stico","info":"Guante fabricado en piel de res de alta calidad, dise\xf1ado para ofrecer excelente durabilidad y comodidad. Cuenta con el\xe1stico en la mu\xf1eca que brinda un ajuste seguro y c\xf3modo. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Argonero","Ajuste":"El\xe1stico en mu\xf1eca","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"argon","materials":["piel"],"imgs":["Argonero_elastico.webp","Argonero_elastico_2.webp"],"colors":{"tag":"color","values":["amarillo natural"]}},{"name":"Operador","info":"Guante fabricado en piel de res de alta calidad con dise\xf1o tipo operador que permite un ajuste ergon\xf3mico y acabado suave. Cuenta con tira ajustable con broche para un ajuste seguro y personalizado. Incorpora bies rojo en el pu\xf1o para mayor refuerzo.","specs":{"Material":"Piel de res","Dise\xf1o":"Tipo operador","Ajuste":"Tira ajustable con broche","Acabado":"Bies rojo en pu\xf1o","Largo":"24 cm","Ancho":"13 cm"},"category":"trabajo-general","materials":["piel"],"imgs":["Operador.webp","Operador_2.webp","Operador_3.webp","Operador_4.webp"],"colors":{"tag":"color","values":["amarillo natural"]}}]');

});

parcelRegister("l7uIn", function(module, exports) {

$parcel$export(module.exports, "images", () => $f60213bb42844d9b$export$6c746a5570b8b35c);
$parcel$export(module.exports, "categoryNames", () => $f60213bb42844d9b$export$135fbf9c72b475d8);
$parcel$export(module.exports, "elementToCard", () => $f60213bb42844d9b$export$5fdc05e0f5efaf36);
$parcel$export(module.exports, "soldadorTable", () => $f60213bb42844d9b$export$57502b0d84861955);

var $hTqAC = parcelRequire("hTqAC");






















const $f60213bb42844d9b$export$6c746a5570b8b35c = {
    'Argonero_de_piel.webp': new URL((parcelRequire("7SNYy"))).href,
    'Argonero_de_piel_2.webp': new URL((parcelRequire("1zJwR"))).href,
    'Argonero_de_piel_4.webp': new URL((parcelRequire("3olXa"))).href,
    'Argonero_de_piel_3.webp': new URL((parcelRequire("gNjTO"))).href,
    'Argonero_elastico.webp': new URL((parcelRequire("euzJw"))).href,
    'Argonero_elastico_2.webp': new URL((parcelRequire("6aHbB"))).href,
    'Operador.webp': new URL((parcelRequire("h7p0p"))).href,
    'Operador_2.webp': new URL((parcelRequire("i9w2I"))).href,
    'Operador_3.webp': new URL((parcelRequire("37vTM"))).href,
    'Operador_4.webp': new URL((parcelRequire("cPTrC"))).href,
    'Soldador_gris.webp': new URL((parcelRequire("gUe5U"))).href,
    'Soldador_gris_2.webp': new URL((parcelRequire("7aVdV"))).href,
    'Soldador_gris_3.webp': new URL((parcelRequire("1I3kA"))).href,
    'Soldador_gris_par.webp': new URL((parcelRequire("3BBA3"))).href,
    'Soldador_azul.webp': new URL((parcelRequire("lr9Z7"))).href,
    'Soldador_azul_2.webp': new URL((parcelRequire("4qz8A"))).href,
    'Soldador_azul_3.webp': new URL((parcelRequire("K8QHP"))).href,
    'Soldador_azul_par.webp': new URL((parcelRequire("2flBv"))).href,
    'Soldador_rojo.webp': new URL((parcelRequire("b34xM"))).href,
    'Soldador_rojo_2.webp': new URL((parcelRequire("lymLx"))).href,
    'Soldador_rojo_3.webp': new URL((parcelRequire("2eDyz"))).href,
    'Soldador_rojo_par.webp': new URL((parcelRequire("c2qNY"))).href
};
const $f60213bb42844d9b$export$135fbf9c72b475d8 = {
    soldadura: 'Soldadura',
    argon: "Arg\xf3n",
    'trabajo-general': 'Trabajo general'
};
const $f60213bb42844d9b$export$f98002053ad6dda2 = {
    azul: '#224575',
    rojo: '#943329',
    gris: '#8a8380',
    'amarillo natural': '#d19a3a'
};
function $f60213bb42844d9b$export$be56b7e53123b17a(product) {
    return './producto.html?ver=' + encodeURIComponent(product.name);
}
function $f60213bb42844d9b$export$ff0eb67b170646b7(product) {
    var color = product.colors && product.colors.values[0];
    return $f60213bb42844d9b$export$f98002053ad6dda2[color] ? '<span class="color-dot" style="--swatch:' + $f60213bb42844d9b$export$f98002053ad6dda2[color] + '" title="' + color + '"></span>' : '';
}
function $f60213bb42844d9b$export$5fdc05e0f5efaf36(product, index) {
    var productUrl = $f60213bb42844d9b$export$be56b7e53123b17a(product);
    var photo = product.imgs.find(function(name) {
        return name.includes('_par');
    }) || product.imgs[0];
    var hoverPhoto = product.imgs.find(function(name) {
        return name !== photo;
    });
    var position = typeof index === 'number' ? '<span class="card-index">' + String(index + 1).padStart(2, '0') + '</span>' : '';
    var facts = [
        [
            'Material',
            product.specs.Material
        ],
        [
            'Longitud',
            product.specs.Longitud || product.specs.Largo
        ],
        [
            product.specs.Costuras ? 'Costuras' : 'Ajuste',
            product.specs.Costuras || product.specs.Ajuste
        ]
    ];
    return `
    <article class="catalog-card wow" data-category="${product.category}">
        <div class="card">
            <a href="${productUrl}" class="card-image-link" aria-label="Ver ficha de ${product.name}">
                <span class="card-category">${$f60213bb42844d9b$export$135fbf9c72b475d8[product.category]}</span>
                <img src="${$f60213bb42844d9b$export$6c746a5570b8b35c[photo]}" alt="${product.name}, vista del producto" loading="lazy" decoding="async" width="400" height="280">
                ${hoverPhoto ? '<img class="card-hover-image" src="' + $f60213bb42844d9b$export$6c746a5570b8b35c[hoverPhoto] + '" alt="" loading="lazy" decoding="async" width="400" height="280">' : ''}
                ${position}
            </a>
            <div class="card-content">
                <h3 class="card-product-title">${$f60213bb42844d9b$export$ff0eb67b170646b7(product)}<a href="${productUrl}">${product.name}</a></h3>
                <dl class="card-facts">${facts.map(function([label, value]) {
        return '<div><dt>' + label + '</dt><dd>' + value + '</dd></div>';
    }).join('')}</dl>
                ${product.specs.Refuerzo ? '<p class="variant-note">' + product.specs.Refuerzo + '</p>' : ''}
                <div class="card-actions">
                    <a href="${productUrl}" class="text-link" aria-label="Ver ficha de ${product.name}">Ver ficha \u{2197}</a>
                    <a href="${(0, $hTqAC.buildQuoteUrl)(product.name)}" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ${product.name} por WhatsApp">Cotizar \u{2197}</a>
                </div>
            </div>
        </div>
    </article>`;
}
const $f60213bb42844d9b$export$cf53f8da0aa21d72 = [
    'Costuras',
    'Refuerzo',
    'Forro',
    'Longitud'
];
function $f60213bb42844d9b$export$57502b0d84861955(products, current) {
    var models = products.filter(function(glove) {
        return glove.category === 'soldadura';
    });
    var head = models.map(function(glove) {
        var name = glove === current ? glove.name + ' <small>(este modelo)</small>' : '<a href="' + $f60213bb42844d9b$export$be56b7e53123b17a(glove) + '">' + glove.name + '</a>';
        return '<th scope="col"' + (glove === current ? ' aria-current="page"' : '') + '>' + $f60213bb42844d9b$export$ff0eb67b170646b7(glove) + name + '</th>';
    }).join('');
    var rows = $f60213bb42844d9b$export$cf53f8da0aa21d72.map(function(key) {
        return '<tr><th scope="row">' + key + '</th>' + models.map(function(glove) {
            var value = glove.specs[key];
            return '<td' + (value ? '' : ' class="is-empty"') + '>' + (value || 'No especificado') + '</td>';
        }).join('') + '</tr>';
    }).join('');
    var actions = '<tr class="compare-actions"><th scope="row">Cotizar</th>' + models.map(function(glove) {
        return '<td><a href="' + (0, $hTqAC.buildQuoteUrl)(glove.name) + '" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ' + glove.name + ' por WhatsApp">Cotizar \u2197</a></td>';
    }).join('') + '</tr>';
    return '<div class="compare-scroll"><table class="compare-table"><caption class="is-sr-only">Comparaci\xf3n de los modelos de soldador</caption><thead><tr><th scope="col"><span class="is-sr-only">Dato</span></th>' + head + '</tr></thead><tbody>' + rows + actions + '</tbody></table></div>';
}

});
parcelRegister("hTqAC", function(module, exports) {

$parcel$export(module.exports, "validQuantity", () => $d06c32ded3014aa3$export$6ea8ebd578e5ebfd);
$parcel$export(module.exports, "buildQuoteUrl", () => $d06c32ded3014aa3$export$c1bf0ec16038ee7d);
$parcel$export(module.exports, "bindQuoteLinks", () => $d06c32ded3014aa3$export$c585aa1941e83dc5);
$parcel$export(module.exports, "initQuoteForm", () => $d06c32ded3014aa3$export$d52eb421dd65a26e);
function $d06c32ded3014aa3$export$6ea8ebd578e5ebfd(value) {
    return value === '' || /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
}
function $d06c32ded3014aa3$export$c1bf0ec16038ee7d(model = '', quantity = '') {
    var message = model ? 'Hola, quiero cotizar el guante ' + model + '.' : 'Hola, quiero cotizar guantes para mi equipo.';
    if (quantity !== '' && $d06c32ded3014aa3$export$6ea8ebd578e5ebfd(quantity)) message += ' Cantidad: ' + quantity + ' pares.';
    if (!model) message += " \xbfMe ayudan a elegir un modelo?";
    return 'https://wa.me/524311032726?text=' + encodeURIComponent(message);
}
function $d06c32ded3014aa3$export$c585aa1941e83dc5(model, quantity, links) {
    function update() {
        quantity.setCustomValidity('');
        var name = typeof model === 'string' ? model : model.value;
        links.forEach(function(link) {
            link.href = $d06c32ded3014aa3$export$c1bf0ec16038ee7d(name, quantity.value);
        });
    }
    quantity.addEventListener('input', update);
    if (typeof model !== 'string') model.addEventListener('change', update);
    links.forEach(function(link) {
        link.addEventListener('click', function(event) {
            quantity.setCustomValidity($d06c32ded3014aa3$export$6ea8ebd578e5ebfd(quantity.value) ? '' : 'Ingresa una cantidad entera mayor que cero.');
            if (!quantity.reportValidity()) event.preventDefault();
        });
    });
    update();
    return update;
}
function $d06c32ded3014aa3$export$d52eb421dd65a26e() {
    var form = /** @type {HTMLFormElement | null} */ document.getElementById('contact-form');
    if (!form) return;
    var model = /** @type {HTMLSelectElement} */ form.elements.namedItem('model');
    var quantity = /** @type {HTMLInputElement} */ form.elements.namedItem('quantity');
    var update = $d06c32ded3014aa3$export$c585aa1941e83dc5(model, quantity, form.querySelectorAll('.quote-contact-link'));
    form.addEventListener('reset', function() {
        setTimeout(update, 0);
    });
}

});

parcelRegister("7SNYy", function(module, exports) {
module.exports = import.meta.resolve("kVjUu");

});

parcelRegister("1zJwR", function(module, exports) {
module.exports = import.meta.resolve("5Ky23");

});

parcelRegister("3olXa", function(module, exports) {
module.exports = import.meta.resolve("2Ha9L");

});

parcelRegister("gNjTO", function(module, exports) {
module.exports = import.meta.resolve("5Uhx2");

});

parcelRegister("euzJw", function(module, exports) {
module.exports = import.meta.resolve("5nxti");

});

parcelRegister("6aHbB", function(module, exports) {
module.exports = import.meta.resolve("eAqK1");

});

parcelRegister("h7p0p", function(module, exports) {
module.exports = import.meta.resolve("e8z96");

});

parcelRegister("i9w2I", function(module, exports) {
module.exports = import.meta.resolve("boQ1I");

});

parcelRegister("37vTM", function(module, exports) {
module.exports = import.meta.resolve("fl4aN");

});

parcelRegister("cPTrC", function(module, exports) {
module.exports = import.meta.resolve("8DBN8");

});

parcelRegister("gUe5U", function(module, exports) {
module.exports = import.meta.resolve("ia1ZY");

});

parcelRegister("7aVdV", function(module, exports) {
module.exports = import.meta.resolve("hLyKv");

});

parcelRegister("1I3kA", function(module, exports) {
module.exports = import.meta.resolve("fH036");

});

parcelRegister("3BBA3", function(module, exports) {
module.exports = import.meta.resolve("8LeHw");

});

parcelRegister("lr9Z7", function(module, exports) {
module.exports = import.meta.resolve("fpf82");

});

parcelRegister("4qz8A", function(module, exports) {
module.exports = import.meta.resolve("in53s");

});

parcelRegister("K8QHP", function(module, exports) {
module.exports = import.meta.resolve("bBQNa");

});

parcelRegister("2flBv", function(module, exports) {
module.exports = import.meta.resolve("coj1k");

});

parcelRegister("b34xM", function(module, exports) {
module.exports = import.meta.resolve("gTJbL");

});

parcelRegister("lymLx", function(module, exports) {
module.exports = import.meta.resolve("7LAN1");

});

parcelRegister("2eDyz", function(module, exports) {
module.exports = import.meta.resolve("457B2");

});

parcelRegister("c2qNY", function(module, exports) {
module.exports = import.meta.resolve("1Hghz");

});


parcelRegister("cVp72", function(module, exports) {

$parcel$export(module.exports, "initReveal", () => $968e49bc9b5b83e7$export$8175101c94c0e570);
/**
 * Lightweight, dependency-free reveal-on-scroll using IntersectionObserver.
 * Replaces the deprecated wow.js library.
 * Honors prefers-reduced-motion and supports dynamic content.
 */ function $968e49bc9b5b83e7$export$8175101c94c0e570(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var container = root || document;
    var elements = container.querySelectorAll('.wow:not(.is-visible):not([data-reveal-observed])');
    if (!elements.length) return;
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var el = entry.target;
                var delayAttr = el.getAttribute('data-reveal-delay') || el.getAttribute('data-wow-delay') || '0';
                var delay = Math.round(parseFloat(delayAttr) * 1000);
                setTimeout(function() {
                    el.classList.add('is-visible');
                }, delay);
                observer.unobserve(el);
            }
        });
    }, {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
    });
    elements.forEach(function(el) {
        el.setAttribute('data-reveal-observed', '');
        observer.observe(el);
    });
    return observer;
}

});


var $gYOZo = parcelRequire("gYOZo");

var $l7uIn = parcelRequire("l7uIn");

var $cVp72 = parcelRequire("cVp72");
var $8f6a480bb40b134f$var$render = document.getElementById('render');
$8f6a480bb40b134f$var$render.innerHTML = '<div class="catalog-grid">' + (0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))).map((0, $l7uIn.elementToCard)).join('') + '</div>';
var $8f6a480bb40b134f$var$cards = $8f6a480bb40b134f$var$render.querySelectorAll('.catalog-card');
document.getElementById('compare-table').innerHTML = (0, $l7uIn.soldadorTable)((0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))));
var $8f6a480bb40b134f$var$tickerItems = (0, (/*@__PURE__*/$parcel$interopDefault($gYOZo))).map(function(glove) {
    return glove.name + " \xb7 " + (glove.specs.Costuras || glove.specs.Ajuste);
}).concat([
    "Hechos en Jalostotitl\xe1n, Jalisco"
]);
var $8f6a480bb40b134f$var$tickerList = '<ul>' + $8f6a480bb40b134f$var$tickerItems.map(function(item) {
    return '<li>' + item + '</li>';
}).join('') + '</ul>';
document.getElementById('ticker').innerHTML = '<div class="ticker-track">' + $8f6a480bb40b134f$var$tickerList + $8f6a480bb40b134f$var$tickerList.replace('<ul>', '<ul aria-hidden="true">') + '</div>';
var $8f6a480bb40b134f$var$filters = document.querySelectorAll('.catalog-filter');
$8f6a480bb40b134f$var$filters.forEach(function(button) {
    button.addEventListener('click', function() {
        $8f6a480bb40b134f$var$filters.forEach(function(filter) {
            var active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', String(active));
        });
        var count = 0;
        $8f6a480bb40b134f$var$cards.forEach(function(card) {
            card.hidden = button.dataset.filter !== 'todos' && card.dataset.category !== button.dataset.filter;
            if (!card.hidden) count++;
        });
        document.getElementById('catalog-count').textContent = count + (count === 1 ? ' modelo' : ' modelos');
        (0, $cVp72.initReveal)($8f6a480bb40b134f$var$render);
    });
});
var $8f6a480bb40b134f$var$tagline = document.querySelector('.tagline-text');
if ($8f6a480bb40b134f$var$tagline && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    Array.from($8f6a480bb40b134f$var$tagline.childNodes).forEach(function(node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var words = node.textContent.trim().split(/\s+/);
        var fragment = document.createDocumentFragment();
        words.forEach(function(word, index) {
            var span = document.createElement('span');
            span.textContent = word;
            fragment.appendChild(span);
            if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
        });
        node.replaceWith(fragment);
    });
    $8f6a480bb40b134f$var$tagline.classList.add('is-animated');
    var $8f6a480bb40b134f$var$words = Array.from($8f6a480bb40b134f$var$tagline.querySelectorAll('span'));
    var $8f6a480bb40b134f$var$observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            setTimeout(function() {
                entry.target.classList.add('is-lit');
            }, $8f6a480bb40b134f$var$words.indexOf(entry.target) * 100);
            $8f6a480bb40b134f$var$observer.unobserve(entry.target);
        });
    }, {
        threshold: 1,
        rootMargin: '0px 0px -20% 0px'
    });
    $8f6a480bb40b134f$var$words.forEach(function(word) {
        $8f6a480bb40b134f$var$observer.observe(word);
    });
}
(0, $cVp72.initReveal)();


//# sourceMappingURL=GuantesGutierrez-design.cb7dbcf3.js.map
